
export default {
    state:{
        hls:false
    },
    actions:{},
    mutations:{
        updateHls(state,content){
            state.hls = content
        }
    },
    getters:{
        getHls(state){
            return state.hls
        }
    },
}